export const SLIDER_SETTINGS = {
  dots: true,
  infinite: true,
  speed: 1000,
  adaptiveHeight: true,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
};
